import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { embargoDateSubmittedFilters, embargoDateReportFormIsOpen } from "../@signals"


export default function useEmbargoReportForm() {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])
    const embargoStatus = useSignal([])
    const includeOnlyNewProducts = useSignal('No')

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        emailsReport.value = [userEmail]
    }

    const handleOpenForm = () => {
        embargoDateReportFormIsOpen.value = true
    }

    const normalizedConditionsFilters = () => {
        return {
            status: embargoStatus.value,
            includeOnlyNewProducts: includeOnlyNewProducts.value === 'Yes',
        }
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'embargoDate',
            conditions: normalizedConditionsFilters(),
            filters: {
                country: embargoDateSubmittedFilters.value.country, retailer: embargoDateSubmittedFilters.value.retailer,
                brand: embargoDateSubmittedFilters.value.brand, skuGroup: embargoDateSubmittedFilters.value.skuGroup,
                sku: embargoDateSubmittedFilters.value.sku, id_customer: userCustomer,
                splitKpi: embargoDateSubmittedFilters.value.splitKpi
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport,
        embargoStatus: embargoStatus,
        includeOnlyNewProducts: includeOnlyNewProducts,
    }
}